var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"localTable"},[_c('easyCruds',{attrs:{"tableInfo":_vm.extTable},on:{"addExtRow":_vm.addExtRow,"Edit":_vm.Edit,"deleteExtRows":_vm.deleteExtRows}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }